import {
    type ApiResult,
    type BaseParams,
    links,
    type ManualOrder,
    type Order,
    type PaginatedResult,
    type PostParams,
    type RefundParams,
    type RefundResponse,
    Request,
    type ResourceId,
} from '@app/client';

export async function refund(
    params: BaseParams & PostParams<RefundParams> & { id: ResourceId },
): Promise<ApiResult<RefundResponse>> {
    return Request.patchRequest<RefundResponse>({
        ...params,
        target: links.orders().refund(params.id).single,
        settings: {
            ...params.settings,
        },
    });
}

export async function getOrder(params: BaseParams & { id: ResourceId }): Promise<ApiResult<Order>> {
    return Request.getRequest<Order>({
        ...params,
        target: links.orders().single(params.id),
        settings: {
            ...params.settings,
        },
    });
}

export interface ManualOrderResponse {
    order: Order;
    validation_result: Record<string, string>;
}
export async function manualOrder(
    params: BaseParams & PostParams<ManualOrder>,
): Promise<ApiResult<ManualOrderResponse>> {
    return Request.postRequest<ManualOrderResponse>({
        ...params,
        target: links.admin().orders().collection(),
        settings: {
            ...params.settings,
        },
    });
}

export async function getOrders(params: BaseParams): Promise<ApiResult<PaginatedResult<Order>>> {
    return Request.getRequest<PaginatedResult<Order>>({
        ...params,
        target: links.admin().orders().collection(),
        settings: {
            ...params.settings,
        },
    });
}
